import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { getAuthPath } from '@libs/entity-lib';
import { getPreviousUrl } from '@libs/settings-state';
import { TranslationLibModule } from '@libs/translation';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { QuickRegisterFormComponent } from './quick-register-form/quick-register-form.component';
import { PlatformDetectionComponent } from '@libs/util-ui';

import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

@Component({
  selector: 'crud-quick-register',
  templateUrl: 'quick-register.component.html',
  styleUrls: ['quick-register.component.scss'],
  imports: [
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    QuickRegisterFormComponent,
    TranslationLibModule,
    PlatformDetectionComponent,
  ],
})
export class QuickRegisterComponent {
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  getPreviousUrl = this.store.selectSignal(getPreviousUrl);

  getBackTextWithTranslation() {
    return this.translate.instant('BACK');
  }

  getDefaultHref() {
    const previousUrl = this.getPreviousUrl();
    // previousUrl é um valor genérico gravado por muitas telas — sem filtro, o
    // "Voltar" do CADASTRO chegou a apontar para /delete-account (sessão que
    // tinha passado pela exclusão de conta). Beco sem saída ou tela de logado
    // não é destino de volta de quem está se cadastrando.
    const blocked = ['/delete-account', '/update-password', '/auth'];
    if (!previousUrl || blocked.some((path) => previousUrl.includes(path))) {
      return '/home';
    }
    return previousUrl;
  }

  /**
   * Troca de idioma (mesmo ícone do wizard antigo, CrudPage). Guarda a URL
   * ATUAL — não a home — para o "voltar" da tela de idiomas devolver o atleta
   * ao cadastro, preservando ?ce= de convite.
   */
  goToLanguage() {
    localStorage.setItem('backUpdateLanguagePath', this.router.url);
    this.router.navigateByUrl('/language/update');
  }

  redirectToAuth() {
    const path = this.route.snapshot.queryParamMap.get('url') ?? this.getDefaultHref();
    this.router.navigate([getAuthPath()], {
      queryParams: { url: encodeURIComponent(path) },
    });
  }
}
